import React from 'react'
import { View, StyleSheet } from 'react-native'
import { useTheme } from '@react-navigation/native'
import Modal from 'react-native-modal'
import { Theme } from '@theme'
import { useCreationStack } from '../../context/CreationStackContext'
import { Icon } from '../atoms/Icon'

const ANIMATION_DURATION = 300

export const CreationStackModal: React.FC = () => {
  const theme = useTheme()
  const styles = getStyle(theme)
  
  const {
    isVisible,
    currentStack,
    hideCreationStack,
    nextStep,
    previousStep,
    goToStep,
    completeStep,
    updateStackData,
    canGoBack,
    canGoNext,
    isLastStep,
    isFirstStep,
    isCreationStackEnabled,
  } = useCreationStack()

  // Only render on web platforms
  if (!isCreationStackEnabled || !currentStack) {
    return null
  }

  const currentStep = currentStack.steps[currentStack.currentStepIndex]
  const CurrentStepComponent = currentStep.component

  const handleBack = () => {
    if (canGoBack) {
      previousStep()
    } else {
      // If can't go back, close the entire modal
      hideCreationStack()
    }
  }

  const handleNext = () => {
    if (canGoNext) {
      nextStep()
    } else if (isLastStep) {
      // Handle completion - this will be implemented in specific step components
      hideCreationStack()
    }
  }

  const handleClose = () => {
    hideCreationStack()
  }


  return (
    <Modal
      isVisible={isVisible}
      onBackdropPress={handleClose}
      onBackButtonPress={handleClose}
      animationIn="slideInRight"
      animationOut="slideOutRight"
      statusBarTranslucent
      animationInTiming={ANIMATION_DURATION}
      animationOutTiming={ANIMATION_DURATION}
      backdropTransitionInTiming={ANIMATION_DURATION}
      backdropTransitionOutTiming={ANIMATION_DURATION}
      style={styles.modal}
      avoidKeyboard
    >
      <View style={styles.container}>
        <View style={styles.closeButton}>
          <Icon
            name="cross"
            size={20}
            color={theme.colors.black}
            onPress={handleClose}
            testID="creation-stack-close"
          />
        </View>
        <CurrentStepComponent 
          stackData={currentStack.data}
          onNext={handleNext}
          onBack={handleBack}
          onClose={handleClose}
          isLastStep={isLastStep}
          isFirstStep={isFirstStep}
          completeStep={completeStep}
          updateStackData={updateStackData}
        />
      </View>
    </Modal>
  )
}

const getStyle = (theme: Theme) => StyleSheet.create({
  modal: {
    margin: 0,
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  container: {
    flex: 1,
    backgroundColor: theme.colors.background,
    width: 400,
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing.xs,
    left: -(20 + theme.spacing.lg),
    padding: theme.spacing.sm,
    paddingRight: theme.spacing.lg,
    borderTopLeftRadius: theme.border.extraLarge,
    borderBottomLeftRadius: theme.border.extraLarge,
    backgroundColor: theme.colors.white,
  },
})
